/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
	Avatar,
	Button,
	Flex,
	HStack,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Spacer,
	Text,
	Wrap,
	WrapItem,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import useStore from '../../store';
import c from '../../constant';
import './style.css';

function DepartmentRemoveModal({ department = null, assignees = [], isOpen = false, onClose = () => null, onCallback = (department) => null }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [users, setUsers] = useState([]);

	useEffect(() => setUsers(assignees), [assignees]);

	return (
		<>
			<Modal isOpen={isOpen} size="xl" onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>
						{t('Unassign')} {lang === 'kh' ? department?.labelKh : department?.label}
					</ModalHeader>
					<ModalCloseButton isDisabled={false} />
					<ModalBody>
						<Text fontWeight="bold">{t('User below will be unassigned')}</Text>
						<Spacer height={2} />
						<Wrap>
							{users?.map((e, i) => (
								<WrapItem className="avatarWraper">
									<Flex direction="column" justifyContent="center" alignItems="center">
										<Avatar
											name={lang === 'kh' ? e?.fullNameKhmer || e?.fullName : e?.fullName || e?.fullNameKhmer}
											src={e?.avatar?.icon ? c.baseFilePath + e?.avatar?.icon : null}
										>
											<FontAwesomeIcon
												onClick={() => setUsers(users?.filter((el) => el?.id !== e?.id))}
												icon={faMinusSquare}
												className="remove"
												style={{
													fontSize: 18,
													display: 'none',
													position: 'absolute',
													zIndex: '100',
													marginLeft: 32,
													marginBottom: 32,
													color: 'red',
													backgroundColor: 'white',
													padding: 2,
													cursor: 'pointer',
												}}
											/>
										</Avatar>
										<Text mt={1} fontWeight="500">
											{lang === 'kh' ? e?.fullNameKhmer || e?.fullName : e?.fullName || e?.fullNameKhmer}
										</Text>
									</Flex>
								</WrapItem>
							))}
						</Wrap>
					</ModalBody>
					<ModalFooter>
						<HStack>
							<Button variant="solid" size="md" colorScheme="gray" onMouseDown={onClose}>
								{t('Cancel')}
							</Button>
							<Button
								variant="solid"
								size="md"
								colorScheme="red"
								onMouseDown={() => {
									onCallback({ ...department, users });
									onClose();
								}}
							>
								{t('Okay')}
							</Button>
						</HStack>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}

export default DepartmentRemoveModal;
